module.exports = __webpack_public_path__ + "static/presidents-message-467773e7ca60cf6a815a4002832e2102.jpg";